import { isPublicHttpsUrl } from "./validateExternalUrl";

const OIDC_DISCOVERY_PATH = "/.well-known/openid-configuration";

// Shape check for an OIDC issuer URL, shared by the SSO admin form (inline
// feedback before submit) and the server mutator (authoritative rejection).
// Returns a user-facing message, or null when the issuer is well-formed.
export function ssoIssuerUrlError(issuer: string): string | null {
  if (!isPublicHttpsUrl(issuer)) {
    return `Issuer URL must be a public HTTPS address: ${issuer}`;
  }
  const issuerUrl = new URL(issuer);
  if (issuerUrl.pathname.includes(OIDC_DISCOVERY_PATH)) {
    return "Enter the issuer URL, not the OIDC discovery URL";
  }
  if (issuerUrl.search || issuerUrl.hash) {
    return "Issuer URL must not contain query parameters or a fragment";
  }
  return null;
}
